import type { ConversationKeysetRowResource } from "@/types_api/backend/transport"
import type { JsonObject } from "@/types/json"
import type { ConversationsTableResult } from "@/types/tables/ConversationsTable"

interface ConversationTransportRow extends ConversationsTableResult {
  agent_id: string | null
  metricsById: Record<string, number | string>
}

type ConversationKeysetRowWithReview = ConversationKeysetRowResource & {
  reviewer_assignees?: string[] | null
  reviewer_status?: "PENDING" | "COMPLETED" | null
}

export function normalizeConversationTransportRow(
  row: ConversationKeysetRowWithReview,
): ConversationTransportRow {
  const metrics: Record<string, number | string> = {}
  const metricsById: Record<string, number | string> = {}
  const metricErrorStatuses: Record<string, string> = {}

  const metricIds = row.metric_ids ?? []
  const outputTypes = row.metric_output_types ?? []
  const stringValues = row.metric_output_string_values ?? []
  const floatValues = row.metric_output_float_values ?? []
  const statuses = row.metric_output_statuses ?? []

  for (let index = 0; index < metricIds.length; index += 1) {
    const metricId = metricIds[index]
    if (!metricId) {
      continue
    }

    const outputType = outputTypes[index]
    const metricKey = metricId

    const metricValue =
      outputType === "float" ? floatValues[index] : stringValues[index]
    if (metricValue !== null && metricValue !== undefined) {
      metrics[metricKey] = metricValue
      metricsById[metricId] = metricValue
    }

    const status = statuses[index]
    if (status) {
      metricErrorStatuses[metricKey] = status
    }
  }

  return {
    run_id: row.run_id ?? "",
    simulation_output_id: row.simulation_output_id ?? null,
    created_at: row.run_created_at ?? "",
    occurred_at: row.run_occurred_at ?? null,
    agent_id: row.run_agent_id ?? null,
    run_status: row.run_status ?? "",
    customer_metadata: (row.run_customer_metadata ?? {}) as JsonObject,
    metrics,
    metricsById,
    explanations: {},
    metadata: {},
    notes: "",
    error_status: "",
    metric_error_statuses: metricErrorStatuses,
    metric_error_messages: {},
    label_status: "UNLABELED",
    tags: row.run_tags ?? [],
    ...(row.reviewer_assignees !== undefined
      ? { reviewer_assignees: row.reviewer_assignees ?? [] }
      : {}),
    ...(row.reviewer_status !== undefined
      ? { reviewer_status: row.reviewer_status ?? null }
      : {}),
  }
}
